import * as _actions from './actions';

const studentReportCommentActions = _actions;
export default studentReportCommentActions;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportComment/index.js